import { connect } from 'react-redux';
import { getViewedProductGroup } from '../../../../../../../../store/associations/selectors';
import ConfirmationInfo from './ConfirmationInfo';

const mapStateToProps = (state) => ({
  viewedProductGroup: getViewedProductGroup(state),
});

export default connect(mapStateToProps)(ConfirmationInfo);
